export function isToolbox() {
    const hostname = window.location.hostname;
    const port = window.location.port;

    if (hostname === 'localhost' && `${hostname}:${port}` === process.env.REACT_APP_DOMAIN_TOOLBOX) {
        return true;
    } else if (hostname === process.env.REACT_APP_DOMAIN_TOOLBOX)
        return true;

    return false;
}